<template>
    <div v-if="isVisible" class="drop-shadow-with-top">
        <table id="header">
            <tr>
                <td><div id="corner-img" class="sprite folded-corner" /></td>
                <td id="title" rowspan="2">
                    {{ title }}
                </td>
                <td id="close" rowspan="2">
                    <img id="close-img" src="~@/assets/images/close.png" @click="$router.go(-1)" />
                </td>
            </tr>
            <tr>
                <td id="corner-img-spacer" colspan="3" />
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'ViewHeader',
        props: {
            isVisible: {
                type: Boolean,
                default: true
            },
            title: String
        }
    }
</script>

<style scoped>
    #header {
        width: 100%;
        text-align: left;
        border-collapse: collapse;
    }

        #header > tr:not(:first-child) {
            background: #FFFFFF;
        }

        #header td:nth-child(2), #header td:nth-child(3) {
            background: #FFFFFF;
        }

        #header td:nth-child(1) {
            width: 30px;
        }

        #header > tr > td {
            padding: 0;
        }

    #close {
        width: 40px;
    }

    #corner-img-spacer {
        height: 10px;
        border-bottom: #C4C4C4 solid 1px;
    }

    #title {
        font-size: larger;
        font-weight: bold;
        border-bottom: #C4C4C4 solid 1px;
    }

    #close-img {
        width: 20px;
    }
</style>